import {getCssVar} from "@web-libs/features/colors/application/colors";
import {CSSProperties} from "react";
import ContentSliderStyles from "./content-slider.module.css";

export const ContentSliderBarItem = ({  active, onClick, style }:{ active: boolean, onClick: () => void, style?: CSSProperties}) => {
    const notActiveBackground = "rgba(255,255,255,0.5)"
    const activeBackground = getCssVar("primary")
    const background = active ? activeBackground : notActiveBackground
    const _styles = {
        width: "100%",
        backgroundColor: background,
        cursor: "pointer",
        ...style
    }
    return (
        <div className={ContentSliderStyles.contentSliderBarItem} onClick={onClick} style={_styles}></div>
    )
}
